import { render } from "./Inventory_view_button.vue?vue&type=template&id=15aa2055&scoped=true"
import script from "./Inventory_view_button.vue?vue&type=script&lang=js"
export * from "./Inventory_view_button.vue?vue&type=script&lang=js"

import "./Inventory_view_button.vue?vue&type=style&index=0&id=15aa2055&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15aa2055"]])

export default __exports__